/**
 * 系统管理  公司管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home/Home' }">Home</el-breadcrumb-item>
      <el-breadcrumb-item>History List</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="Search：">
        <el-input size="small" v-model="formInline.firstName" placeholder="First Name"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.lastName" placeholder="Last Name"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-select size="small" v-model="formInline.mode" clearable  placeholder="Mode">
            <el-option label="HRS" value="HRS">HRS</el-option>
            <el-option label="HRM" value="HRM">HRM</el-option>
            <el-option label="SRSM" value="SRSM">SRSM</el-option>
            <el-option label="SRMM" value="SRMM">SRMM</el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="creationTime">
        <el-date-picker size="small" v-model="formInline.creationTime" type="daterange" align="right" unlink-panels range-separator="To" start-placeholder="Start Date" end-placeholder="Ending Date" :picker-options="pickerOptions"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">Search</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :default-sort = "{prop: 'creationTime', order: 'ascending'}" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="Loading..." style="width: 100%;">
      <!-- <el-table-column align="center" type="selection" width="60"></el-table-column> -->
      <el-table-column align="center" prop="firstName" label="First Name" width="200"></el-table-column>
      <el-table-column align="center" prop="lastName" label="Last Name" width="200"></el-table-column>
      <el-table-column align="center" prop="sex" label="Gender" width="200"></el-table-column>
      <el-table-column align="center" prop="mode" label="Treatment Type" width="200">
        <!-- <template slot-scope="scope">
          <div>{{scope.row.editTime|timestampToTime}}</div>
        </template> -->
      </el-table-column>
      <el-table-column align="center" prop="skinType" label="Skin Type" width="200"></el-table-column>
      <el-table-column align="center" prop="fluence" label="Fluence" width="200"></el-table-column>
      <el-table-column align="center" prop="pulse" label="Pulse" width="200"></el-table-column>
      <el-table-column align="center" prop="frequency" label="Frequency" width="200"></el-table-column>
      <el-table-column align="center" prop="cooling" label="Cooling" width="200"></el-table-column>
      <el-table-column align="center" prop="counter" label="Shots" width="200"></el-table-column>
      <el-table-column align="center" prop="status" label="Status" width="200"></el-table-column>
      <el-table-column align="center" prop="creationTime" label="creationTime" width="200"></el-table-column>
      <el-table-column align="center" label="Operation" fixed="right" min-width="100">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="checkPlan(scope.$index, scope.row)">Check</el-button>
          <!-- <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">Delete</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 诊疗计划 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="80%" @click="closeDialog">
      <el-table size="small" :default-sort = "{prop: 'creationTime', order: 'ascending'}" :data="planList" highlight-current-row v-loading="loading" border element-loading-text="Loading..." style="width: 100%;">
        <el-table-column align="center" type="index" width="54"></el-table-column>
        <el-table-column align="center" prop="fromMachine" label="Serial Number" width="160"></el-table-column>
        <el-table-column align="center" prop="mode" label="Treatment Type" width="160"></el-table-column>
        <!-- <el-table-column align="center" prop="mode" label="Treatment Part" width="110"> -->
          <!-- <template slot-scope="scope">
            <div>{{scope.row.editTime|timestampToTime}}</div>
          </template> -->
        </el-table-column>
        <el-table-column align="center" prop="skinType" label="Skin Type" width="160"></el-table-column>
        <el-table-column align="center" prop="fluence" label="Fluence" width="160"></el-table-column>
        <el-table-column align="center" prop="pulse" label="Pulse" width="160"></el-table-column>
        <el-table-column align="center" prop="frequency" label="Frequency" width="160"></el-table-column>
        <el-table-column align="center" prop="cooling" label="Cooling" width="160"></el-table-column>
        <el-table-column align="center" prop="counter" label="Shots" width="160"></el-table-column>
        <el-table-column align="center" prop="creationTime" label="creationTime" width="160"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { getHistory } from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '',
      formInline: {
        page: 1,
        firstName: '',
        lastName: '',
        sex: '',
        mode: '',
        skinType: '',
        fluence: '',
        pulse: '',
        frequency: '',
        cooling: '',
        counter: '',
        operator: '',
        history: '',
        belonging: JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin' ? JSON.parse(localStorage.getItem('userdata'))._source.belonging : '',
        status: '',
        creationTime: ''
      },
      planformInline: {
        page: 1,
        firstName: '',
        lastName: '',
        mode: '',
        operator: '',
        creationTime: ''
      },
      planList: [],
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        page: 1,
        total: 10
      },
      pickerOptions: {
        shortcuts: [{
          text: 'Latest week',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Last month',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    console.log(this.formInline);
    this.getHistoryList(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取美容中心列表
    getHistoryList(parameter) {
      this.loading = true
      getHistory(parameter)
        .then(res => {
          this.loading = false
          if (res.code === 201) {
            this.listData = res.data;
            // 分页赋值
            this.pageparm.page = this.formInline.page;
            this.pageparm.total = res.total;
          } else {
            this.listData = res.data
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.count
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('Menu failed to load, please try again later！')
        })
    },
    getPlanList(parameter) {
      this.loading = true
      getHistory(parameter)
        .then(res => {
          this.loading = false
          if (res.code === 201) {
            this.planList = res.data;
            // 分页赋值
            this.pageparm.page = this.formInline.page;
            this.pageparm.total = res.total;
          } else {
            this.planList = res.data
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.count
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('Menu failed to load, please try again later！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      console.log(this.formInline);
      this.getHistoryList(this.formInline)
    },
    checkPlan(index,row){
      this.editFormVisible = true
      this.planformInline.firstName = row.firstName
      this.planformInline.lastName = row.lastName
      this.getPlanList(this.planformInline);
      console.log(this.planformInline);
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/system/history.vue